import { BrokerWriteGate } from '@/features/brokers/components/broker-write-gate.component';
import { useSelectedBrokerWriteGuard } from '@/features/brokers/hooks';
import { PmeProposalPage } from '@/features/proposals/components';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_app/proposals/$id/pme/edit/')({
  component: RouteComponent,
  validateSearch: z.object({
    startStep: z.enum(['insurance', 'resume']).optional(),
  }),
  beforeLoad: async () => {
    const hasPermission = await requirePermissions([
      'policies.proposals.write',
    ]);
    if (!hasPermission) {
      throw redirect({ to: '/proposals' });
    }
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { startStep } = Route.useSearch();
  const proposalWriteGuard = useSelectedBrokerWriteGuard('proposal');
  return (
    <BrokerWriteGate guard={proposalWriteGuard} backTo='/proposals'>
      <PmeProposalPage
        proposalId={id}
        mode='edit'
        // Editar abre no RESUMO: é de lá que o corretor confere a proposta e
        // segue para a assinatura, e é para lá que ele volta depois da aprovação
        // da subscrição — desde que as etapas anteriores estejam concluídas;
        // senão o wizard abre na primeira pendente. `?startStep=insurance`
        // força o começo do wizard.
        startStep={startStep ?? 'resume'}
      />
    </BrokerWriteGate>
  );
}
